// extracted by mini-css-extract-plugin
export default {"content":"ProjectsPage_content__e393R","element":"ProjectsPage_element__7VCZr","container":"ProjectsPage_container__4pQdE"};